var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { throttle } from 'lodash-es';
import { translate } from '../utilities/translate';
import { sdsCustomElement } from '../utilities/custom-components';
import { SdsGalleryItemBase } from './item/_sds-gallery-item-base';
import { GalleryDisplayPossibilityOptions } from './resources/gallery-display-possibility-options';
import styles from './sds-gallery.lit.scss';
import stylesFullScreen from './sds-gallery-full-screen.lit.scss';
/**
 * Gallery component that renders Image or Video items.
 *
 * @tag sds-gallery
 */
let SdsGallery = (() => {
    var _SdsGallery_displayOption_accessor_storage, _SdsGallery_ratio_accessor_storage, _SdsGallery_activeItemIdentifier_accessor_storage, _SdsGallery__items_accessor_storage, _SdsGallery__galleryMainItemWrapper_accessor_storage, _SdsGallery__pagingWrapper_accessor_storage, _SdsGallery__sdsGalleryThumbItemsWrapper_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-gallery')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _displayOption_decorators;
    let _displayOption_initializers = [];
    let _displayOption_extraInitializers = [];
    let _ratio_decorators;
    let _ratio_initializers = [];
    let _ratio_extraInitializers = [];
    let _activeItemIdentifier_decorators;
    let _activeItemIdentifier_initializers = [];
    let _activeItemIdentifier_extraInitializers = [];
    let __items_decorators;
    let __items_initializers = [];
    let __items_extraInitializers = [];
    let __galleryMainItemWrapper_decorators;
    let __galleryMainItemWrapper_initializers = [];
    let __galleryMainItemWrapper_extraInitializers = [];
    let __pagingWrapper_decorators;
    let __pagingWrapper_initializers = [];
    let __pagingWrapper_extraInitializers = [];
    let __sdsGalleryThumbItemsWrapper_decorators;
    let __sdsGalleryThumbItemsWrapper_initializers = [];
    let __sdsGalleryThumbItemsWrapper_extraInitializers = [];
    var SdsGallery = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsGallery_displayOption_accessor_storage.set(this, __runInitializers(this, _displayOption_initializers, void 0));
            _SdsGallery_ratio_accessor_storage.set(this, (__runInitializers(this, _displayOption_extraInitializers), __runInitializers(this, _ratio_initializers, void 0)));
            _SdsGallery_activeItemIdentifier_accessor_storage.set(this, (__runInitializers(this, _ratio_extraInitializers), __runInitializers(this, _activeItemIdentifier_initializers, '')));
            _SdsGallery__items_accessor_storage.set(this, (__runInitializers(this, _activeItemIdentifier_extraInitializers), __runInitializers(this, __items_initializers, void 0)));
            _SdsGallery__galleryMainItemWrapper_accessor_storage.set(this, (__runInitializers(this, __items_extraInitializers), __runInitializers(this, __galleryMainItemWrapper_initializers, void 0)));
            _SdsGallery__pagingWrapper_accessor_storage.set(this, (__runInitializers(this, __galleryMainItemWrapper_extraInitializers), __runInitializers(this, __pagingWrapper_initializers, void 0)));
            _SdsGallery__sdsGalleryThumbItemsWrapper_accessor_storage.set(this, (__runInitializers(this, __pagingWrapper_extraInitializers), __runInitializers(this, __sdsGalleryThumbItemsWrapper_initializers, void 0)));
            this._galleryItems = (__runInitializers(this, __sdsGalleryThumbItemsWrapper_extraInitializers), []);
            // Template Handlers
            this.slotChangeHandler = throttle(() => {
                this._items.forEach(item => {
                    if (!this._galleryItems.includes(item)) {
                        this._galleryItems.push(item);
                    }
                });
                this.requestUpdate();
            }, 100, {
                leading: true,
                trailing: true,
            });
            this.windowKeydown = (event) => {
                if (this.isInFullScreen) {
                    switch (event.code) {
                        case 'Escape':
                            this.toggleFullscreen();
                            break;
                        case 'ArrowLeft':
                            this.toPreviousItem();
                            break;
                        case 'ArrowRight':
                            this.toNextItem();
                            break;
                    }
                }
            };
            this.windowResize = () => {
                if (!this.isInFullScreen) {
                    this.updateMainItemStyles();
                }
            };
        }
        /**
         * Full screen mode
         * @attr
         */
        get displayOption() { return __classPrivateFieldGet(this, _SdsGallery_displayOption_accessor_storage, "f"); }
        set displayOption(value) { __classPrivateFieldSet(this, _SdsGallery_displayOption_accessor_storage, value, "f"); }
        /**
         * Gallery ratio
         * @attr
         */
        get ratio() { return __classPrivateFieldGet(this, _SdsGallery_ratio_accessor_storage, "f"); }
        set ratio(value) { __classPrivateFieldSet(this, _SdsGallery_ratio_accessor_storage, value, "f"); }
        /**
         * Active Item Identifier
         * @attr
         */
        get activeItemIdentifier() { return __classPrivateFieldGet(this, _SdsGallery_activeItemIdentifier_accessor_storage, "f"); }
        set activeItemIdentifier(value) { __classPrivateFieldSet(this, _SdsGallery_activeItemIdentifier_accessor_storage, value, "f"); }
        get _items() { return __classPrivateFieldGet(this, _SdsGallery__items_accessor_storage, "f"); }
        set _items(value) { __classPrivateFieldSet(this, _SdsGallery__items_accessor_storage, value, "f"); }
        get _galleryMainItemWrapper() { return __classPrivateFieldGet(this, _SdsGallery__galleryMainItemWrapper_accessor_storage, "f"); }
        set _galleryMainItemWrapper(value) { __classPrivateFieldSet(this, _SdsGallery__galleryMainItemWrapper_accessor_storage, value, "f"); }
        get _pagingWrapper() { return __classPrivateFieldGet(this, _SdsGallery__pagingWrapper_accessor_storage, "f"); }
        set _pagingWrapper(value) { __classPrivateFieldSet(this, _SdsGallery__pagingWrapper_accessor_storage, value, "f"); }
        get _sdsGalleryThumbItemsWrapper() { return __classPrivateFieldGet(this, _SdsGallery__sdsGalleryThumbItemsWrapper_accessor_storage, "f"); }
        set _sdsGalleryThumbItemsWrapper(value) { __classPrivateFieldSet(this, _SdsGallery__sdsGalleryThumbItemsWrapper_accessor_storage, value, "f"); }
        render() {
            return html `
            ${this.getTemplate()}
            <slot style="display: none;" @slotchange="${this.slotChangeHandler}"></slot>
        `;
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            this.updateThumbItemStyles();
            this.updateMainItemStyles();
            this.updateActiveThumbItemPosition();
            this.updatePagingData();
        }
        connectedCallback() {
            super.connectedCallback();
            this.addListeners();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeListeners();
        }
        getTemplate() {
            if (!this._galleryItems || !this._galleryItems.length) {
                return html `
                <sds-empty data-card-content="">
                    <sds-illustration name="image" slot="illustration"></sds-illustration>
                    <div slot="title">${translate('sds.gallery.no.data')}</div>
                </sds-empty>
            `;
            }
            return html `
            <div class="${this.isInFullScreen ? 'sds-gallery-full-screen' : ''}">
                <div style="position: relative;">
                    <div id="galleryMainItemWrapper" class="sds-gallery-main-wrapper">
                        ${this.mainItem()}
                    </div>

                    <div
                        id="pagingWrapper"
                        class="sds-gallery-paging-wrapper ${this.isInFullScreen
                ? 'sds-gallery-paging-wrapper-full'
                : 'sds-gallery-paging-wrapper-default'}"
                    ></div>

                    <span
                        id="sdsGalleryPrevSlide"
                        class="sds-gallery-action-wrapper sds-gallery-item-slider-left-arrow ${this
                .isInFullScreen
                ? 'sds-gallery-main-action-wrapper-full sds-gallery-item-slider-left-arrow-full'
                : 'sds-gallery-main-action-wrapper-default sds-gallery-item-slider-left-arrow-default'}"
                        @click="${() => this.toPreviousItem()}"
                    >
                        <sds-icon
                            size="${this.isInFullScreen ? '24' : '16'}"
                            name="arrow_left_thin"
                        ></sds-icon>
                    </span>

                    <span
                        id="sdsGalleryNextSlide"
                        class="sds-gallery-action-wrapper sds-gallery-item-slider-right-arrow ${this
                .isInFullScreen
                ? 'sds-gallery-main-action-wrapper-full sds-gallery-item-slider-right-arrow-full'
                : 'sds-gallery-main-action-wrapper-default sds-gallery-item-slider-right-arrow-default'}"
                        @click="${() => this.toNextItem()}"
                    >
                        <sds-icon
                            size="${this.isInFullScreen ? '24' : '16'}"
                            name="arrow_right_thin"
                        ></sds-icon>
                    </span>
                </div>
                <div class="sds-gallery-thumbs">
                    <div
                        id="sdsGalleryThumbItemsWrapper"
                        class="sds-gallery-thumb-items-wrapper ${this.isInFullScreen
                ? 'sds-gallery-thumb-items-wrapper-full'
                : 'sds-gallery-thumb-items-wrapper-default'}"
                    >
                        ${this.thumbItems()}
                    </div>
                </div>
            </div>
        `;
        }
        mainItem() {
            const activeItem = this._galleryItems.find(i => i.identifier === this.activeItemIdentifier) ||
                this._galleryItems[0];
            // save active item id
            this.activeItemIdentifier = activeItem.identifier;
            // clone active element
            const item = activeItem === null || activeItem === void 0 ? void 0 : activeItem.cloneNode(true);
            item.setAttribute('id', 'galleryMainItem');
            item.setAttribute('is-main-mode', 'true');
            item.setAttribute('display-option', this.displayOption);
            item.addEventListener(SdsGalleryItemBase.FULL_SCREEN_EVENT, () => {
                this.toggleFullscreen();
            });
            return item;
        }
        thumbItems() {
            return this._galleryItems.map(item => {
                item.setAttribute('display-option', this.displayOption);
                return html ` <div
                id="thumbItem${item.identifier}"
                class="sds-gallery-thumb-item ${this.isInFullScreen
                    ? 'sds-gallery-thumb-item-full'
                    : 'sds-gallery-thumb-item-default'}"
            >
                ${item}
                <div
                    class="${item.identifier == this.activeItemIdentifier
                    ? 'sds-gallery-thumb-active-item-cover'
                    : ''} sds-gallery-thumb-item-cover"
                    data-identifier="${item.identifier}"
                    @click="${() => this.updateMainItem(item)}"
                ></div>
            </div>`;
            });
        }
        get isInFullScreen() {
            return this.displayOption === GalleryDisplayPossibilityOptions.FULL;
        }
        // Gallery Actions
        toPreviousItem() {
            if (this._galleryItems.length === 1) {
                return;
            }
            const activeMainItemIndex = this._galleryItems.findIndex(i => i.identifier === this.activeItemIdentifier);
            const newItem = activeMainItemIndex === 0
                ? this._galleryItems[this._galleryItems.length - 1]
                : this._galleryItems[activeMainItemIndex - 1];
            this.updateMainItem(newItem);
        }
        toNextItem() {
            if (this._galleryItems.length === 1) {
                return;
            }
            const activeMainItemIndex = this._galleryItems.findIndex(i => i.identifier === this.activeItemIdentifier);
            const newItem = activeMainItemIndex === this._galleryItems.length - 1
                ? this._galleryItems[0]
                : this._galleryItems[activeMainItemIndex + 1];
            this.updateMainItem(newItem);
        }
        toggleFullscreen() {
            if (this.isInFullScreen) {
                // Remove Styles
                document.head.removeChild(document.getElementById('sdsGalleryFullScreenStyle'));
                // Remove HTML
                document.body.removeChild(document.getElementById('sdsGalleryInFullScreen'));
            }
            else {
                // Add Styles
                const sdsGalleryFullScreenStyles = document.createElement('style');
                sdsGalleryFullScreenStyles.id = 'sdsGalleryFullScreenStyle';
                sdsGalleryFullScreenStyles.innerHTML = stylesFullScreen.cssText;
                document.head.appendChild(sdsGalleryFullScreenStyles);
                // Add HTML
                const sdsGalleryFullScreenWrapper = document.createElement('sds-gallery');
                sdsGalleryFullScreenWrapper.setAttribute('id', 'sdsGalleryInFullScreen');
                sdsGalleryFullScreenWrapper.setAttribute('class', 'sds-gallery-in-full-screen');
                sdsGalleryFullScreenWrapper.setAttribute('active-item-identifier', `${this.activeItemIdentifier}`);
                sdsGalleryFullScreenWrapper.setAttribute('display-option', GalleryDisplayPossibilityOptions.FULL);
                document.body.appendChild(sdsGalleryFullScreenWrapper);
                this._galleryItems.forEach(i => {
                    sdsGalleryFullScreenWrapper.appendChild(i.cloneNode(true));
                });
            }
        }
        // Update Functions
        updateMainItem(item) {
            if (this.activeItemIdentifier !== item.identifier) {
                this.activeItemIdentifier = item.identifier;
                this.dispatchGalleryItemChange();
            }
        }
        updateThumbItemStyles() {
            var _a;
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-gallery-thumb-item-cover').forEach(thumbItem => {
                thumbItem.classList.remove('sds-gallery-thumb-active-item-cover');
                if (thumbItem.getAttribute('data-identifier') === this.activeItemIdentifier) {
                    thumbItem.classList.add('sds-gallery-thumb-active-item-cover');
                }
            });
        }
        updateMainItemStyles() {
            if (this._galleryMainItemWrapper) {
                const mainItemRect = this._galleryMainItemWrapper.getBoundingClientRect();
                let ratio = 2 / 3;
                if (this.ratio) {
                    const ratioParams = this.ratio.split('/');
                    ratio = +ratioParams[0] / +ratioParams[1];
                }
                this._galleryMainItemWrapper.style.height = `${ratio * mainItemRect.width}px`;
            }
        }
        updatePagingData() {
            if (this._galleryItems.length && this._pagingWrapper) {
                const activeItemIndex = this._galleryItems.findIndex(i => i.identifier === this.activeItemIdentifier);
                this._pagingWrapper.innerText = `${activeItemIndex + 1} / ${this._galleryItems.length}`;
            }
        }
        updateActiveThumbItemPosition() {
            var _a;
            const activeThumbItem = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(`thumbItem${this.activeItemIdentifier}`);
            if (this._galleryItems.length && activeThumbItem && this._sdsGalleryThumbItemsWrapper) {
                const sdsGalleryThumbItemPadding = 8;
                const scrollLeft = activeThumbItem.offsetLeft +
                    activeThumbItem.offsetWidth / 2 -
                    sdsGalleryThumbItemPadding -
                    this._sdsGalleryThumbItemsWrapper.offsetWidth / 2;
                this._sdsGalleryThumbItemsWrapper.scrollTo(scrollLeft, 0);
            }
        }
        // Event Listeners
        addListeners() {
            window.addEventListener('keydown', this.windowKeydown);
            window.addEventListener('resize', this.windowResize);
        }
        removeListeners() {
            window.removeEventListener('keydown', this.windowKeydown);
            window.removeEventListener('resize', this.windowResize);
        }
        // Dispatch Events
        dispatchGalleryItemChange() {
            this.dispatchEvent(new CustomEvent(SdsGallery.CHANGE_EVENT, {
                detail: {
                    value: this.activeItemIdentifier,
                },
                bubbles: false,
                composed: false,
            }));
        }
    };
    _SdsGallery_displayOption_accessor_storage = new WeakMap();
    _SdsGallery_ratio_accessor_storage = new WeakMap();
    _SdsGallery_activeItemIdentifier_accessor_storage = new WeakMap();
    _SdsGallery__items_accessor_storage = new WeakMap();
    _SdsGallery__galleryMainItemWrapper_accessor_storage = new WeakMap();
    _SdsGallery__pagingWrapper_accessor_storage = new WeakMap();
    _SdsGallery__sdsGalleryThumbItemsWrapper_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsGallery");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _displayOption_decorators = [property({ type: String, attribute: 'display-option', reflect: true })];
        _ratio_decorators = [property({ type: String, attribute: 'ratio', reflect: true })];
        _activeItemIdentifier_decorators = [property({
                type: String,
                attribute: 'active-item-identifier',
                reflect: true,
                hasChanged: newVal => {
                    if (typeof newVal !== 'string') {
                        console.warn(`Unexpected Identifier ${typeof newVal}`);
                        return false;
                    }
                    return true;
                },
            })];
        __items_decorators = [queryAssignedElements()];
        __galleryMainItemWrapper_decorators = [query('#galleryMainItemWrapper')];
        __pagingWrapper_decorators = [query('#pagingWrapper')];
        __sdsGalleryThumbItemsWrapper_decorators = [query('#sdsGalleryThumbItemsWrapper')];
        __esDecorate(_classThis, null, _displayOption_decorators, { kind: "accessor", name: "displayOption", static: false, private: false, access: { has: obj => "displayOption" in obj, get: obj => obj.displayOption, set: (obj, value) => { obj.displayOption = value; } }, metadata: _metadata }, _displayOption_initializers, _displayOption_extraInitializers);
        __esDecorate(_classThis, null, _ratio_decorators, { kind: "accessor", name: "ratio", static: false, private: false, access: { has: obj => "ratio" in obj, get: obj => obj.ratio, set: (obj, value) => { obj.ratio = value; } }, metadata: _metadata }, _ratio_initializers, _ratio_extraInitializers);
        __esDecorate(_classThis, null, _activeItemIdentifier_decorators, { kind: "accessor", name: "activeItemIdentifier", static: false, private: false, access: { has: obj => "activeItemIdentifier" in obj, get: obj => obj.activeItemIdentifier, set: (obj, value) => { obj.activeItemIdentifier = value; } }, metadata: _metadata }, _activeItemIdentifier_initializers, _activeItemIdentifier_extraInitializers);
        __esDecorate(_classThis, null, __items_decorators, { kind: "accessor", name: "_items", static: false, private: false, access: { has: obj => "_items" in obj, get: obj => obj._items, set: (obj, value) => { obj._items = value; } }, metadata: _metadata }, __items_initializers, __items_extraInitializers);
        __esDecorate(_classThis, null, __galleryMainItemWrapper_decorators, { kind: "accessor", name: "_galleryMainItemWrapper", static: false, private: false, access: { has: obj => "_galleryMainItemWrapper" in obj, get: obj => obj._galleryMainItemWrapper, set: (obj, value) => { obj._galleryMainItemWrapper = value; } }, metadata: _metadata }, __galleryMainItemWrapper_initializers, __galleryMainItemWrapper_extraInitializers);
        __esDecorate(_classThis, null, __pagingWrapper_decorators, { kind: "accessor", name: "_pagingWrapper", static: false, private: false, access: { has: obj => "_pagingWrapper" in obj, get: obj => obj._pagingWrapper, set: (obj, value) => { obj._pagingWrapper = value; } }, metadata: _metadata }, __pagingWrapper_initializers, __pagingWrapper_extraInitializers);
        __esDecorate(_classThis, null, __sdsGalleryThumbItemsWrapper_decorators, { kind: "accessor", name: "_sdsGalleryThumbItemsWrapper", static: false, private: false, access: { has: obj => "_sdsGalleryThumbItemsWrapper" in obj, get: obj => obj._sdsGalleryThumbItemsWrapper, set: (obj, value) => { obj._sdsGalleryThumbItemsWrapper = value; } }, metadata: _metadata }, __sdsGalleryThumbItemsWrapper_initializers, __sdsGalleryThumbItemsWrapper_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsGallery = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.CHANGE_EVENT = 'sds.gallery-item.change';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsGallery = _classThis;
})();
export { SdsGallery };
